export enum IUserProperties {
    LanguageId = 'LanguageId',
    TourId = 'TourId',
    Grouping = 'Grouping',
}

export type IUserStateCallback<T = unknown> = (name: string, newValue: T) => void;

export interface IUserState {
    getProperty: <T>(name: IUserProperties | string) => T | undefined;
    getPropertyWithDefault: <T extends string | number | boolean>(
        name: IUserProperties | string,
        defaultValue: T,
    ) => T;
    setProperty: (name: IUserProperties | string, value: unknown | undefined) => void;
    subscribeChanges: <T>(
        name: IUserProperties | string,
        callback: IUserStateCallback<T>,
        subscriberKey?: string,
    ) => void;
    unsubscribeChanges: <T>(
        name: IUserProperties | string,
        callback: IUserStateCallback<T>,
    ) => void;
    subscriber: <T>(subscriberKey: string) => IUserStateCallback<T> | undefined;
    flatten: () => string;
}

export interface IUserStateInstantiator {
    open: (name: string) => IUserState;
    expand: (data: string) => IUserState;
}
